import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import profileReducer from '../features/profile/profileSlice';
import eventReducer from '../features/event/eventSlice';
import userReducer from '../features/user/userSlice';
import meetingReducer from '../features/meeting/meetingSlice';
import paymentReducer from '../features/payment/paymentSlice'
import bookingConfigReducer from '../features/booking/bookingConfigSlice';
import todoReducer from '../features/todo/todoSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    event: eventReducer,
    meeting: meetingReducer,
    user: userReducer,
    profile: profileReducer,
    payment: paymentReducer,
    bookingConfig: bookingConfigReducer,
    todo: todoReducer,

  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});
